<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Damage from "./damage.vue";
import Scrap from "./scrap.vue";
import Warehousing from "./warehousing.vue";
import JSZip from "jszip";
import FileSaver from "file-saver";
import config from "@/utils/config";
import checkDeskShow from "./checkDeskShow.vue";

export default {
  extends: baseList,
  components: {
    Damage,
    Warehousing,
    Scrap,
    checkDeskShow,
  },
  data() {
    return {
      table: {
        mname: "device",
        key: "id",
        url: {
          del: "/admin/system/facility",
        },
        output: false,
        order: "updateTime",
        qrCode: "qrCode",
      },
      menus: [
        {
          label: "使用中",
          name: "deviceretrieval_list",
          auth: "system/deviceretrieval/index",
          badge: { mname: "decicestate", scene: "2" },
        },
        {
          label: "库存中",
          name: "device_list",
          auth: "system/device/index",
          badge: { mname: "decicestate", scene: "1" },
        },

        {
          label: "已损坏",
          name: "devicedamage_list",
          auth: "system/devicedamage/index",
          badge: { mname: "decicestate", scene: "3" },
        },
        {
          label: "已报废",
          name: "devicescrap_list",
          auth: "system/devicescrap/index",
          badge: { mname: "decicestate", scene: "4" },
        },
        // {
        //   label: "备用库",
        //   name: "devicestandby_list",
        //   auth: "system/devicestandby/index",
        //   badge: { mname: "decicestate", scene: "5" },
        // },
        {
          label: "空码库",
          name: "Emptycode_list",
          auth: "",
          badge: { mname: "decicestate", scene: "6" },
        },
        // {
        //   label: "资产分类",
        //   name: "deviceClass_list",
        //   auth: "system/deviceClass/index",
        // },
        // { label: '入库记录', name: 'deviceRecordretrieval_list', auth: '' },
        // { label: '损坏记录', name: 'deviceRecorddamage_list', auth: '' },
        // { label: '场景管理', name: 'scene_list', auth: '' },
      ],
      query: {
        state: 2,
      },
      actions: [
        {
          label: "导出标签",
          icon: "md-cloud-download",
          type: "info",
          onClick: this.downloadCodeImg,
          auth: "system/deviceretrieval/downloadCodeImg",
        },
        {
          label: "导出资产",
          icon: "md-download",
          type: "info",
          onClick: this.exportData.bind(this, "资产列表", 1),
          auth: "system/deviceretrieval/exportData",
        },
        {
          label: "批量同步二维码",
          icon: "ios-cloud-done-outline",
          onClick: this.torefall,
          auth: "",
          type: "info",
        },
        {
          label: "同步核算科室",
          icon: "ios-cloud-done-outline",
          onClick: this.toSynchronizeDesk,
          auth: "",
          type: "info",
        },
        {
          label: "加入抄张",
          icon: "md-add",
          onClick: this.setAccountRecordAll,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "安装时间",
          name: "installationTime",
          value: "",
          type: "datetimerange",
          KeyEnter: this.search,
        },
        {
          label: "厂家",
          KeyEnter: this.search,
          name: "manufacturer",
          value: "",
          type: "input",
        },
        {
          label: "型号",
          KeyEnter: this.search,
          name: "facilityType",
          value: "",
          type: "input",
        },
        {
          label: "资产分类",
          name: "typeId",
          value: "",
          type: "select",
          KeyEnter: this.search,
          dropList: [],
        },
        {
          label: "设备名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "SN码",
          KeyEnter: this.search,
          name: "sn",
          value: "",
          type: "input",
        },
        // {
        //   label: "物理位置",
        //   name: "installationSite",
        //   value: "",
        //   type: "input",
        //   KeyEnter: this.search,
        // },
        {
          label: "资产归属",
          name: "assetOwnership",
          value: "",
          type: "input",
          KeyEnter: this.search,
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
        {
          label: "IP/MAC",
          KeyEnter: this.search,
          name: "ipMac",
          value: "",
          type: "input",
        },
        {
          label: "责任人",
          KeyEnter: this.search,
          name: "liablePerson",
          value: "",
          type: "input",
        },
        {
          label: "核算科室",
          KeyEnter: this.search,
          name: "checkDeskId",
          value: "",
          type: "select",
          dropList: [],
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "资产编号",
          key: "assetNum",
          width: 100,
          align: "center",
          tooltip: "true",
        },
        {
          title: "二维码",
          width: 80,
          align: "center",
          key: "qrCode",
          viewimage: true,
        },
        /*    {
             title: "资产归属",
             key: "assetOwnership",
             minWidth: 100,
             align: "center",
             tooltip: "true",
           }, */
        {
          title: "型号",
          minWidth: 150,
          align: "center",
          key: "facilityType",
          tooltip: "true",
        },
        /* {
          title: "类型",
          key: "typeName",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },
         {
          title: "品牌",
          minWidth: 100,
          align: "center",
          key: "facilityBrand",
          tooltip: "true",
        }, */
        {
          title: "核算科室",
          key: "checkDeskName",
          minWidth: 150,
          align: "center",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            const text = row.checkDeskName ? row.checkDeskName : "";
            const list = this.checkListArr;
            return (
              <checkDeskShow
                text={text}
                item={row}
                type={1}
                list={list}
                onReset={() => {
                  this.search();
                }}
              />
            );
          },
        },
        {
          title: "使用科室",
          key: "deskName",
          minWidth: 150,
          align: "center",
          tooltip: "true",
        },
        {
          title: "物理地址",
          minWidth: 150,
          align: "center",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            return (
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={
                    (row.buildingName ? row.buildingName + "-" : "") +
                    (row.floorName ? row.floorName + "-" : "") +
                    (row.room ? row.room : "")
                  }
                  placement="bottom"
                >
                  <div
                    style={{
                      width: "100%",
                      overflow: "hidden",
                      "text-overflow": "ellipsis",
                      "white-space": "nowrap",
                    }}
                  >
                    {" "}
                    {row.buildingName ? row.buildingName + "-" : ""}
                    {row.floorName ? row.floorName + "-" : ""}
                    {row.room ? row.room : ""}
                  </div>
                </el-tooltip>
              </div>
            );
          },
        },
        {
          title: "盘点次数",
          key: "checkCount",
          width: 120,
          align: "center",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.checkCount == null ? 0 : row.checkCount;
            return <span style="font-size: 14px">{text}</span>;
          },
        },
        {
          title: "维修次数",
          key: "maintainCount",
          width: 120,
          align: "center",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.maintainCount == null ? 0 : row.maintainCount;
            return <span style="font-size: 14px">{text}</span>;
          },
        },
        /*
         {
          title: "状态",
          minWidth: 80,
          align: "center",
          key: "state",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "库存中"
                : row.state == 2
                  ? "使用中"
                  : row.state == 3
                    ? "已损坏"
                    : row.state == 4
                      ? "已报废"
                      : row.state == 5
                        ? "备用库"
                        : "";
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        }, */
        {
          title: "操作",
          align: "center",
          width: 230,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/deviceretrieval/ref" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toref(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "8px",
                    marginTop: "5px",
                  }}
                >
                  同步
                </Button>
              );
            },
            /*  (vm, h, currentRow, param) => {
               // let directives = [];
               let directives = [
                 { name: "auth", value: "system/deviceretrieval/info" },
               ];
               return (
                 <Button
                   {...{ directives }}
                   size="small"
                   onClick={() => this.handleEdit(currentRow)}
                   type="default"
                   style={{
                     border: "none",
                     color: "#4991ff",
                     marginRight: "5px",
                     marginTop: "5px",
                   }}
                 >
                   详情
                 </Button>
               );
             }, */
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/deviceretrieval/into" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.tointo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                    marginTop: "5px",
                  }}
                >
                  回库
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/deviceretrieval/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginTop: "5px",
                  }}
                >
                  详情记录
                </Button>
              );
            },
            //  (vm, h, currentRow, param) => {
            //   let directives = [];
            //   // let directives = [{ name: 'auth', value: '/admin/device/edit' }]
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.todamage(currentRow)}
            //       type="default"
            //       style={{
            //         border: "none",
            //         color: "#4991ff", marginTop: "5px", marginRight: "5px"}}
            //     >
            //       损坏
            //     </Button>
            //   );
            // },

            // (vm, h, currentRow, param) => {
            //   // let directives = [];
            //   let directives = [
            //     {name: "auth", value: "system/deviceretrieval/record"},
            //   ];
            //   return (
            //       <Button
            //           {...{directives}}
            //           size="small"
            //           onClick={() => this.torecord(currentRow)}
            //           type="warning"
            //           style={{marginTop: "5px",marginRight: "5px", color: "#f6f7f8"}}
            //       >
            //         操作记录
            //       </Button>
            //   );
            // },

            // (vm, h, currentRow, param) => {
            //   let directives = [];
            //   // let directives = [{ name: 'auth', value: '/admin/device/edit' }]
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.toscrap(currentRow)}
            //       type="error"
            //       style={{ marginRight: "5px", color: "#f6f7f8" }}
            //     >
            //       报废
            //     </Button>
            //   );
            // },
          ],
          auth: {
            edit: "system/deviceretrieval/edit",
          },
        },
      ],
      CheckDeskList: [],
      checkListArr: [],
    };
  },
  created() {
    this.checkData();
    this.loadLevelData();
    this.loaddeskData();
    this.getCheckDeskList();
  },
  methods: {
    setAccountRecordAll() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要加入抄张的资产");
        return true;
      }
      console.log(this.selected);

      let q = {};
      q.facilityIds = this.selected.split(",");
      $utils.api
        .load("/admin/system/facility/updateFacilityToMeterReading", q, "post")
        .then((res) => {
          if (res.code == 200) {
            $utils.toast.success(res.msg);
            this.search();
          }
        });
    },
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code == 200) {
        let data = res.rows;
        let dropList = [];
        if (data && data.length > 0) {
          dropList = data.map((item) => ({
            value: item.id,
            label: item.checkDeskName,
            disabled: !item.children || item.children.length === 0,
            children: (item.children || []).map((child) => ({
              value: child.id,
              label: child.checkDeskName,
            })),
          }));
        }
        this.checkListArr = dropList;
      }
    },
    handleSelect(selected) {
      let ids_arr = [];
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
        arry.push(element[this.table.qrCode]);
      }
      this.selected = ids_arr.join(",");
      this.arrys = arry;
    },
    //批量删除
    batchDelete() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要删除的资产");
        return true;
      }
      this.$Modal.success({
        title: "确认是否要删除?",
        showOk: false,
        closable: true,
        width: "1000px",
        render: (h) => {
          return (
            <div style="width:100%;display:flex;justify-content:center; ">
              <Button
                type="primary"
                onClick={() => {
                  this.onBatchDelete();
                }}
              >
                确定
              </Button>
            </div>
          );
        },
      });
      {
        /* this.$Modal.confirm({
        content: "<p>确认是否要删除?</p>",
        showOk: true,
        closable: true,
        onOk: () => {

        },
        onCancel: () => {
          this.$Modal.remove();
        },
      }); */
      }
    },
    onBatchDelete() {
      let q = this.selected;
      $utils.api
        .load(`/admin/system/facility/batch/${q}`, "", "DELETE")
        .then((res) => {
          if (res && res.rows) {
            this.$Modal.remove();
            $utils.toast.success(res.msg);
            // setTimeout(() => {
            // $utils.url.go(0);
            this.search();
            // }, 300);
          }
        });
    },
    loadIMage(image) {
      return new Promise(function (resolve, reject) {
        try {
          image.onload = function () {
            resolve();
          };
        } catch (e) {
          reject();
        }
      });
    },
    async downloadCodeImg() {
      if (this.arrys == null) $utils.toast.warn("请选择需要导出标签");
      // this.msg('请选择数据')
      const arry = this.arrys;
      for (var j = 0; j < arry.length; j++) {
        if (arry[j].indexOf("http") === -1) {
          arry[j] = config.IMAGE_HOST + arry[j];
        }
      }
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let date = nowDate.getDate();
      var blogTitle = "资产二维码标签" + year + month + date;
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = ['http://weixiu.kafukeji.com/admin/profile/upload/code/GK21112200028.png', ];
      // 下载后图片的文件名，个数应与arr对应
      // var imgNameList = ['图片1', '图片2', '图片3'];
      for (var i = 0; i < arry.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.src = arry[i];
        await this.loadIMage(image);

        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);

        let url = canvas.toDataURL(); // 得到图片的base64编码数据
        canvas.toDataURL("image/png");
        baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
        if (baseList.length === arry.length && baseList.length > 0) {
          for (let k = 0; k < baseList.length; k++) {
            imgs.file(
              arry[k].substring(arry[k].lastIndexOf("/") + 1, arry[k].length),

              baseList[k],
              { base64: true }
            );
          }
          zip.generateAsync({ type: "blob" }).then(function (content) {
            // see FileSaver.js
            FileSaver.saveAs(content, blogTitle + ".zip");
          });
        }
      }
      //如果没有跨越问题直接用图片地址
      // let arry = ['https://api.pwmqr.com/qrcode/create/?url=GK21112500039', 'https://api.pwmqr.com/qrcode/create/?url=GK21112200029'];
      // (arry.forEach(function (url, index) {
      //   setTimeout(() => {//setTimeout是为了防止arry太多导致下载终端机
      //     let link = document.createElement('a')
      //     // 这里是将url转成blob地址，
      //     fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
      //       link.href = URL.createObjectURL(blob)
      //       let temp = url.split("?");
      //       temp = temp[0].split("/");
      //       let name = temp[temp.length - 1];//获得图片名字
      //       link.download = name;
      //       document.body.appendChild(link);
      //       link.click()
      //     })
      //   }, index * 1000)//1000是为了使得浏览器能稳定下载  这个时间可自调建议大于500
      // }))
    },
    //同步核算科室
    toSynchronizeDesk() {
      this.sloading = true;
      $utils.api
        .load(`/admin/system/facility/sync`, "", "GET")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success(res.msg);
            this.search();
            // if (res.msg) {
            // setTimeout(() => {
            // $utils.url.go(0);

            // }, 500);
            // }
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    //同步二维码
    torefall() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要同步二维码的资产");
        return true;
      }
      this.id = this.selected;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/facility/refreshBatch/${this.id}`, "", "GET")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success(res.msg);
            if (res.msg) {
              // setTimeout(() => {
              // $utils.url.go(0);
              this.search();
              // }, 500);
            }
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    toref(currentRow) {
      this.id = currentRow.id;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/facility/refresh/${this.id}`)
        .then((res) => {
          this.sloading = false;
          console.log(res);

          if (res.status) {
            $utils.toast.success("同步成功");
            // setTimeout(() => {
            // $utils.url.go(0);
            this.search();
            // }, 300);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api
            .load(`/admin/system/desk/selectList`, q, "get")
            .then((res) => {
              const list = res.rows.map((item) => {
                return {
                  value: item.id,
                  name: item.deskName,
                };
              });
              for (let index = 0; index < this.filters.length; index++) {
                const element = this.filters[index];
                if (element && element.name == "deskId") {
                  this.filters[index]["dropList"] = list;
                }
              }
            });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api
        .load(`/admin/system/desk/selectList/?isParent=${"0"}`, q)
        .then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.deskName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
          }
        });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      q.state = 2;
      $utils.api
        .load("/admin/system/facilityType/selectList", q)
        .then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.facilityName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "typeId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
          }
        });
    },
    checkData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/check/listNoChild", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.checkDeskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "checkDeskId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "device_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "device_edit",
        query: { action: "view", kv: currentRow.id },
      });
    },
    tointo(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "返回库存",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Warehousing
              style={{ margin: "0", color: "#19be6b" }}
              facilityId={row.id}
              createBy={row.createBy}
              onReset={() => {
                this.search();
              }}
            ></Warehousing>
          );
        },
      });
    },
    todamage(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "损坏",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Damage
              style={{ margin: "0", color: "#19be6b" }}
              facilityId={row.id}
              createBy={row.createBy}
            ></Damage>
          );
        },
      });
    },
    toscrap(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "报废",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Scrap
              style={{ margin: "0", color: "#19be6b" }}
              facilityId={row.id}
              createBy={row.createBy}
            ></Scrap>
          );
        },
      });
    },
    //记录
    toInfo(row) {
      $utils.url.push({
        name: "deviceRecordIndex",
        query: { facilityId: row.id, facilityNo: row.facilityNum },
      });
    },
    //操作记录
    torecord(row) {
      $utils.url.push({
        name: "deviceRecordIndex",
        query: { facilityId: row.id },
      });
    },
    //导出
    toImport() { },
    //下载模板
    toDownload() { },
  },
};
</script>
<style scoped></style>
